import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, SxProps, Tooltip, Typography } from "@mui/material";
import useCopyText from "../hooks/useCopyText";

type CopyableTypographyProps = {
  text: string;
  displayText?: string;
  variant?: "body1" | "body2" | "caption" | "h6" | "h5" | "h4" | "h3" | "h2" | "h1";
  color?: string;
  sxProps?: SxProps;
};

const CopyableTypography = ({
  text,
  displayText = text,
  variant = "body2",
  color = "text.secondary",
  sxProps = {},
}: CopyableTypographyProps) => {
  const { copyToClipboard, isCopied } = useCopyText();

  return (
    <Tooltip
      title={
        <Box>
          <Box sx={{ mb: 0.5, fontWeight: "bold" }}>{isCopied ? "Copied!" : "Click to copy"}</Box>
          <Box sx={{ fontFamily: "monospace", fontSize: "0.75rem", wordBreak: "break-all" }}>
            {text}
          </Box>
        </Box>
      }
      arrow
      placement="top"
    >
      <Box
        sx={{ display: "flex", gap: 1, cursor: "pointer", alignItems: "center", minWidth: 0 }}
        onClick={() => copyToClipboard(text)}
      >
        <Typography
          variant={variant}
          color={color}
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            fontFamily: "monospace",
            fontSize: { xs: "0.8rem", sm: "0.875rem" },

            ...sxProps,
          }}
        >
          {displayText}
        </Typography>
        {isCopied ? (
          <CheckCircleOutlineIcon
            sx={{ fontSize: "inherit", ml: 0.5, color: "success.main", flexShrink: 0 }}
          />
        ) : (
          <ContentCopyIcon
            sx={{ fontSize: "inherit", ml: 0.5, color: "text.primary", flexShrink: 0 }}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default CopyableTypography;
